import { CVDisplay } from "./components/CVDisplay";

import type { CVData } from "./types/cv";
import "./index.css";
import cvData from "../assets/cv.json";

export function App() {
  return <CVDisplay cvData={cvData as CVData} />;
}

export default App;
